<template>
  <div class="container" :style="'background:'+$store.state.theme.themeSubColor">
    <div class="header">
      <div class="bg" :style="'background:'+$store.state.theme.themeColor"></div>
      <p class="title">{{$store.state.theme.name ? $store.state.theme.name : '全国青少年编程能力测评系统'}}</p>
      <div class="info">
        <p v-if="testInfo.account">考生账号：{{ testInfo.account }}</p>
        <p>交卷时间：{{ endTime | date('Y-m-d H:i') }}</p>
      </div>
    </div>
    <div class="test-content">
      <answer-content :question-list="questionList"
                      :total-count="totalCount"
                      :current-question-id="currentQuestionId"
                      @changeQuestion="changeQuestion"></answer-content>
      <question-content
        :question="currentQuestion"
        @nextQuestion="nextQuestion"
        @prevQuestion="prevQuestion"
        :is-last="isLast"
        :is-first="isFirst"
        :is-making="isMaking"
      ></question-content>
    </div>
  </div>
</template>

<script>
import AnswerContent from './AnswerContent'
import QuestionContent from './QuestionContent'
// import { formatDate } from '@/utils/base'
import { mapState } from 'vuex'
import { get } from '@/utils/ajax'
export default {
  components: {
    AnswerContent,
    QuestionContent
  },
  watch: {
    currentQuestion (n) {
      this.isFirst = n.questionId === this.previewDetail[0].questionId
      this.isLast = n.questionId === this.previewDetail[this.previewDetail.length - 1].questionId
    }
  },
  computed: {
    ...mapState(['testInfo'])
  },
  async mounted() {
    // 未来教室老师查看试卷
    if (this.$route.query.examId && this.$route.query.userId) {
      this.getPreviewDetail(true)
    } else {
      await this.$store.dispatch('getTestInfo')
      this.getPreviewDetail()
    }
  },
  data () {
    return {
      currentQuestion: {},
      currentQuestionId: 0,
      questionList: [],
      questionNum: 0,
      isLast: false,
      isFirst: false,
      isMaking: true,
      hiddenPrev: false,
      currentPaper: [],
      previewDetail: [],
      account: '',
      endTime: '',
      totalCount: 0,
      examName: ''
    }
  },
  methods: {
    async getPreviewDetail (isShowPage) {
      const paperId = localStorage.examineeId
      const examId = this.$route.query.id ? this.$route.query.id : localStorage.examId
      let data = []
      if (isShowPage) {
        data = await get(`/home/edu/examineeExamRecode/exams/${this.$route.query.examId}/users/${this.$route.query.userId}/papers`)
      } else {
        data = await get(`/home/edu/examineeExamRecode/${examId}/${paperId}/paper`)
      }
      // if (!data.account) {
      //   return
      // }
      this.account = data.account
      this.examName = data.exam_name
      this.endTime = data.end_time
      this.totalCount = data.total_score
      data.question_infos.forEach(t => {
        Object.assign(t, t.questionOption)
      })
      this.previewDetail = data.question_infos
      this.currentPaper = this.initPaperIndex(data.question_infos)
      this.initAnswerArea(this.currentPaper)
      this.currentQuestion = data.question_infos[0]
      this.currentQuestionId = data.question_infos[0].questionId
    },
    initPaperIndex (data) {
      const typeArr = []
      const questionObj = {}
      let resArr = []
      data.forEach((t, i) => {
        if (!questionObj[t.typeName]) {
          typeArr.push({
            typeName: t.typeName,
            indexList: [t]
          })
          questionObj[t.typeName] = t
        } else {
          typeArr.forEach(_t => {
            if (_t.typeName === t.typeName) {
              _t.indexList.push(t)
            }
          })
        }
      })
      typeArr.forEach(t => {
        resArr = resArr.concat(t.indexList)
      })
      return resArr
    },
    initAnswerArea (data) {
      const typeArr = []
      const questionObj = {}
      data.forEach((t, i) => {
        const isCorrect = t.score !== 0
        if (!questionObj[t.typeName]) {
          typeArr.push({
            typeId: t.typeId,
            typeName: t.typeName,
            indexList: [{
              id: t.questionId,
              index: i + 1,
              isFinish: !!t.answer,
              isCorrect: isCorrect
            }]
          })
          questionObj[t.typeName] = t
        } else {
          typeArr.forEach(_t => {
            if (_t.typeName === t.typeName) {
              _t.indexList.push({
                id: t.questionId,
                index: i + 1,
                isFinish: !!t.answer,
                isCorrect: isCorrect
              })
            }
          })
        }
      })
      this.questionList = typeArr
    },
    changeQuestion (id) {
      this.previewDetail.forEach(t => {
        if (t.questionId === id) {
          this.currentQuestion = t
          this.currentQuestionId = t.questionId
        }
      })
    },
    prevQuestion (id) {
      this.previewDetail.forEach((t, i) => {
        if (t.questionId === id) {
          this.currentQuestion = this.previewDetail[i - 1]
          this.currentQuestionId = this.previewDetail[i - 1].questionId
        }
      })
    },
    nextQuestion (id) {
      this.previewDetail.forEach((t, i) => {
        if (t.questionId === id) {
          this.currentQuestion = this.previewDetail[i + 1]
          this.currentQuestionId = this.previewDetail[i + 1].questionId
        }
      })
    },
    formatDate (date) {
      return date
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1400px;
  display: flex;
  flex-direction: column;
  background-color: #F5F9FF;
}
.header {
  width: 100%;
  height: 257px;
  min-height: 257px;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 40px 0;
  z-index: 1;
  overflow: hidden;
  .bg {
    position: absolute;
    width: 18000px;
    height: 18000px;
    border-radius: 50%;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  }
  .title {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
    line-height: 42px;
    padding-top: 45px;
  }
  .info {
    width: 500px;
    font-size: 16px;
    color: #fff;
    line-height: 42px;
    padding-top: 55px;
    display: flex;
    justify-content: space-between;
  }
}
.test-content {
  width: 100%;
  height: calc(100% - 110px);
  flex: 1;
  display: flex;
  padding: 0 40px;
  position: relative;
  z-index: 2;
  margin-top: -157px;
}
</style>
